module.exports = __webpack_public_path__ + "static/media/sfyg-mobile-app-combined.9c609ac2.png";